import { Button, Card } from "antd";
import styled from "styled-components";

export const WidgetDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  gap: 40px;
`;

export const AppointmentWidget = styled(Card)`
  border-color: transparent;
  box-shadow: 0px 4px 10px rgb(0 0 0 / 3%);
  /* width: 33%; */
  height: 150px;
  border-radius: 15px;
  color: #ffffff;
`;

export const Widget = styled.div`
  display: flex;
  border-right: ${(props) => (props.border ? "1px solid #f0f0f0" : "none")};
  justify-content: flex-start;
`;

export const WidgetBody = styled.div`
  color: rgba(0, 0, 0, 0.85) !important;
  margin-right: 0px;
  margin-left: 15px;
  justify-content: flex-start;
`;

export const WidgetTitle = styled.h6`
  font-size: 16px;
  margin-bottom: 0px;
  @media (max-width: 768px) {
    font-size: 14px;
  }
  @media (max-width: 820px){
    font-size: 12px;
    font-weight: 600;
  }
  @media (max-width: 281px) {
    font-size: 10px;
  }
  @media (max-width: 1150px) and (min-width:992px) {
    font-size: 9px;
  }
`

export const WidgetDescription = styled.h2`
  margin-bottom: 0px;
  font-weight: bold;
  font-size: 32px;
`;

export const EarningBookingWidget = styled(Card)`
  border-color: transparent;
  box-shadow: 0px 4px 10px rgb(0 0 0 / 3%);
  /* width: 48%; */
  height: 150px;
  /* background: linear-gradient(96.51deg, #F2A13A 0.39%, #EE752F 98.83%); */
  border-radius: 15px;
  color: #000;
  p {
    margin-bottom: 0px;
  }
  .title {
    font-size: 22px;
  }
  .money {
    font-size: 32px;
    font-weight: bold;
  }
  .profit {
    font-size: 14px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
`;

export const EarningBookingLeftDiv = styled.div`
  position: absolute;
  width: 142.83px;
  height: 120px;
  left: 0;
  top: 0;
  background: rgba(213, 213, 213, 0.15);
  border-radius: 15px 0px 150px;
`;
export const EarningBookingRightDiv = styled.div`
  position: absolute;
  width: 102.02px;
  height: 80px;
  right: 0;
  bottom: 0;
  background: rgba(213, 213, 213, 0.15);
  border-radius: 15px 0px 100px;
  transform: rotate(-180deg);
`;
export const EarningBookingVectorDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const BookingHeadingDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const BookingHeading = styled.span`
  font-size: 20px;
  font-weight: 600;
  color: #3a3e4d;
`;
export const ViewAllButton = styled(Button)`
  color: ${(props) => props.theme.colors.primary};
  font-weight: bold;
`;

export const BookingWidget = styled(Card)`
  border-color: transparent;
  box-shadow: 0px 4px 10px rgb(0 0 0 / 3%);
  /* width: 33%; */
  height: 127px;
  border-radius: 15px;
  color: #ffffff;
  .ant-card-body {
    padding: 0;
  }
`;
export const BookingWidgetDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const BookingWidgetLeftDiv = styled.div`
  display: flex;
  flex-direction: column;
  /* flex-grow:2; */
  width: 80px;
  background: linear-gradient(165.1deg, #b383c8 0%, #8438a7 100%);
  border-radius: 15px 0px 0px 15px;
  height: 126px;
`;
export const BookingWidgetRightDiv = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 8;
  height: 126px;
`;
export const BookingWidgetLeftTopDiv = styled.div`
  /* flex-grow:8; */
  height: 96px;
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  p {
    margin: 0;
  }
  p.day {
    font-size: 32px;
  }
`;
export const BookingWidgetLeftBottomDiv = styled.div`
  /* flex-grow:2; */
  box-shadow: 0px 4px 10px rgb(0 0 0 / 3%);
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  align-items: center;
`;
export const BookingWidgetRightTopDiv = styled.div`
  /* flex-grow:1; */
  height: 96px;
  // display: flex;
  // flex-wrap: wrap;
  // align-content: flex-start;
  // justify-content: center;
  // align-items: flex-start;
  // flex-direction: column;
  padding: 8px;
  p {
    margin: 0;
  }
  p.name {
    color: black;
  }
  p.appno {
    color: #200543;
    font-size: 12px;
  }
  p.time {
    // display: flex;
    color: #7a2f9c;
    font-size: 14px;
    font-weight: 600;
  }
`;
export const BookingWidgetRightBottomDiv = styled.div`
  /* flex-grow:2; */
  border-top: 1px solid #f0f0f0;
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  justify-content: flex-start;
  align-items: flex-start;
  padding-left: 8px;
  p {
    margin: 0;
    color: #3a3e4d;
    font-size: 12px;
  }
`;

export const ArticleCard = styled(Card)`
  border-color: transparent;
  box-shadow: 0px 4px 10px rgb(0 0 0 / 3%);
  /* width: 33%; */
  height: 360px;
  border-radius: 15px;
  .ant-card-body {
    padding: 8px 18px;
  }
  .ant-card-cover img {
    border-radius: 15px 15px 0px 0px;
    width: 100%;
    height: 250px;
  }

  p {
    margin: 0;
    color: #121111;
    font-size: 14px;
    font-weight: 600;
  }
  div.description {
    display: flex;
    flex-direction: column;
    p {
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  div.views {
    gap: 7px;
    display: flex;
    align-content: flex-start;
    justify-content: flex-start;
    align-items: center;
    color: #a3a9bf;
    font-size: 12px;
    margin-top: 8px;
  }
  @media (max-width: 768px) {
    height: 102%;
  }
  // @media (max-width: 768px){
  //   height: 250px;
  // }
`;
export const ArticleTagCard = styled(Card)`
  border-color: transparent;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  /* width: 33%; */
  height: 180px;
  border-radius: 15px;
  color: #ffffff;
`;

export const ArticleTagBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const ArticleTagTitleBody = styled.div`
  text-align: center;
`;